import { useState, useEffect } from "react";
import { useBooking, roundEuros } from "../../store/bookingStore";
import classes from "./EquipmentContainer.module.css";

/** Parse "14.00 € / Stück" or similar to a number (euros). */
function parsePriceEuros(price) {
    if (typeof price === "number" && Number.isFinite(price)) return price;
    const s = String(price);
    const m = s.match(/[\d.,]+/);
    if (!m) return 0;
    return parseFloat(m[0].replace(",", ".")) || 0;
}

/**
 * Card: "Dazubuchen" only when switch row (!counted). Modal: always show "Dazubuchen" on the left.
 */
export function EquipmentBookingActions({
    onOpenDetails,
    equipmentItemId,
    name,
    price,
    maxCount = 1,
    counted,
    counts,
    checked,
    layout = "card",
}) {
    const { bookingData, updateBookingData } = useBooking();
    const [count, setCount] = useState(counts);
    const [isChecked, setIsChecked] = useState(checked);
    const priceValue = roundEuros(parsePriceEuros(price));

    useEffect(() => {
        setCount(counts);
    }, [counts]);

    useEffect(() => {
        setIsChecked(checked);
    }, [checked]);

    const handleEquipmentChange = (newCount) => {
        const currentEquipment = bookingData.equipment || [];
        if (!counted) return;

        if (newCount === 0) {
            updateBookingData(
                "equipment",
                currentEquipment.filter(
                    (item) =>
                        (equipmentItemId ? item.equipmentItemId !== equipmentItemId : item.name !== name)
                )
            );
            return;
        }
        const totalPrice = roundEuros(priceValue * newCount);
        const updatedEquipment = currentEquipment.filter(
            (item) => (equipmentItemId ? item.equipmentItemId !== equipmentItemId : item.name !== name)
        );
        updatedEquipment.push({
            equipmentItemId: equipmentItemId || undefined,
            name,
            count: newCount,
            totalPrice,
        });
        updateBookingData("equipment", updatedEquipment);
    };

    const incrementCount = () => {
        if (!counted) return;
        const cap = Math.max(1, maxCount);
        const newCount = Math.min(count + 1, cap);
        if (newCount === count) return;
        setCount(newCount);
        handleEquipmentChange(newCount);
    };

    const decrementCount = () => {
        if (count <= 0) return;
        const newCount = count - 1;
        setCount(newCount);
        handleEquipmentChange(newCount);
    };

    const handleToggle = (e) => {
        const next = e.target.checked;
        setIsChecked(next);

        const currentEquipment = bookingData.equipment || [];

        if (next) {
            updateBookingData("equipment", [
                ...currentEquipment.filter((item) =>
                    equipmentItemId ? item.equipmentItemId !== equipmentItemId : item.name !== name
                ),
                {
                    equipmentItemId: equipmentItemId || undefined,
                    name,
                    checked: true,
                    totalPrice: priceValue,
                },
            ]);
        } else {
            updateBookingData(
                "equipment",
                currentEquipment.filter((item) =>
                    equipmentItemId ? item.equipmentItemId !== equipmentItemId : item.name !== name
                )
            );
        }
    };

    const showDazubuchen = layout === "modal" || !counted;
    const rowClass =
        layout === "modal"
            ? classes.equipmentCountModal
            : counted
              ? classes.equipmentCountRowCounted
              : classes.equipmentCount;

    return (
        <div className={rowClass}>
            {showDazubuchen ? <h3 className="regularLarge">Dazubuchen</h3> : null}

            {layout === "card" ? (
            <button 
                type="button"
                className={`${classes.detailsButtonPhone} semiboldXs`}
                onClick={() => onOpenDetails?.()}
            >
                Details
            </button>
            ) : null}
            
            {counted ? (
                <div className={classes.equipmentCountButtons}>
                    <span className={`${classes.equipmentCountButton} regularLarge`}>{count}</span>
                    <div className={ layout === "modal" ? classes.equipmentCountButtonsContainerModal : classes.equipmentCountButtonsContainer}>
                        <button type="button" onClick={decrementCount} aria-label="Weniger">
                            &#8722;
                        </button>
                        <div className={classes.verticalLine}></div>
                        <button type="button" onClick={incrementCount} aria-label="Mehr">
                            &#43;
                        </button>
                    </div>
                </div>
            ) : (
                <div className={classes.switchContainer}>
                    <label className={classes.switchBlockTimes}>
                        <input type="checkbox" checked={isChecked} onChange={handleToggle} />
                        <span className={classes.sliderBlockTimes}></span>
                    </label>
                </div>
            )}
        </div>
    );
}
